export default "__VITE_ASSET__DZDckBDa__"